<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ getCategoryTitle(lang_Mix) }}
    </h1>
    <div class="main_wrap">
      <div class="mobiSection">
        <div class="mobiSection__header">
          <h2 class="mobiTitle md text_color">
            <span>{{ getCategoryTitle(lang_Mix) }} {{ $t("categories") }}</span>
          </h2>
        </div>
        <div class="mobiSection__content">
          <div v-if="isLoaded.subCategory === false">
            <svg class="spinner" viewBox="0 0 50 50">
              <circle
                class="path"
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke-width="5"
              ></circle>
            </svg>
          </div>
          <div class="mobislider" v-if="isLoaded.subCategory === true">
            <miximo-slider
              :sliderData="subcategory"
              :cat="cat.sub"
              :category="category"
              ref="childComponent"
            ></miximo-slider>
          </div>
        </div>
      </div>
      <div class="mobiSection">
        <div class="mobiSection__header">
          <h2 class="mobiTitle md">
            <img class="mobiIcon" :src="HotPickIcon_Mix" alt="" />
            <span class="text_color">{{ $t("hotpicks") }}</span>
          </h2>
        </div>
        <div class="mobiSection__content">
          <div v-if="isLoaded.hotpicks === false">
            <svg class="spinner" viewBox="0 0 50 50">
              <circle
                class="path"
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke-width="5"
              ></circle>
            </svg>
          </div>
          <div class="sliderWrap" v-if="isLoaded.hotpicks === true">
            <miximo-slider
              :hotpick="hotpicks"
              :cat="cat.hot"
              :category="category"
              ref="hotPickComponent"
            ></miximo-slider>
          </div>
        </div>
      </div>
      <div class="mobiSection">
        <div class="mobiSection__header">
          <h2 class="mobiTitle md">
            <img class="mobiIcon" :src="PopularIcon_Mix" alt="" />
            <span class="text_color">{{ $t("popular") }}</span>
          </h2>
        </div>
        <div class="mobiSection__content">
          <div v-if="isLoaded.popular === false">
            <svg class="spinner" viewBox="0 0 50 50">
              <circle
                class="path"
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke-width="5"
              ></circle>
            </svg>
          </div>
          <div class="sliderWrap" v-if="isLoaded.popular === true">
            <miximo-slider
              :popular="popular"
              :cat="cat.pop"
              :category="category"
              ref="popularComponent"
            ></miximo-slider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { mapGetters } from "vuex";
import MiximoSlider from "../MiximoSlider.vue";
import country_list from "../../../locales/country_list.json";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);
const currentDate = new Date();
let day = currentDate.getDay();

export default {
  data() {
    return {
      category: "",
      categoryTranslate: "",
      subcategory: {},
      hotpicks: {},
      popular: {},
      cat: {
        hot: "hot",
        pop: "pop",
        sub: "sub"
      },
      isLoaded: {
        hotpicks: false,
        popular: false,
        subCategory: false,
        subCategoryAr: false
      }
    };
  },
  computed: mapGetters(["HotPickIcon_Mix", "PopularIcon_Mix", "lang_Mix", "country_Mix", "host_Mix"]),
  components: {
    "miximo-slider": MiximoSlider,
    "star-rating": StarRating
  },
  created() {
    let c = this.$route.params.category;
    //if route have '_' will change to space
    let cat = c.replace("_", " ");
    //split category name and category id
    let cate = cat.split("-");
    this.category = cate[0];

    this.getCatHotPicks(cate[0]);
    this.getCatPopular(cate[0]);
    this.getSubcategory(cate[0], cate[1]);
  },
  methods: {
    async getCatHotPicks(category) {
      let local = `http://[::1]/PuretechGlobalContentPortal/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=${category}&limit=10&offset=0&domain=${this.host_Mix}`
      let live = `http://cook.grabmobi.com/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=${category}&limit=25&offset=0&domain=${this.host_Mix}&lang=${this.lang_Mix}`;
      await axios.get(live)
        .then(res => {
          let data = res.data.data;
          data.sort(function(a, b) {
            //to sort random
            return 0.5 - Math.random();
          });

          this.isLoaded.hotpicks = true;
          this.hotpicks = data;
          setTimeout(() => {
            this.$refs.hotPickComponent.triggerFn("hotPicksSlider");
          }, 0);
        })
        .catch(err => {
          console.log(err);
        });
    },
    async getCatPopular(category) {
      let local = `http://[::1]/PuretechGlobalContentPortal/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=${category}&limit=10&offset=0&domain=${this.host_Mix}`
      let live = `http://cook.grabmobi.com/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=${category}&limit=10&offset=0&domain=${this.host_Mix}&lang=${this.lang_Mix}`;
      await axios.get(live)
        .then(res => {
          let data = res.data.data;
          data.sort(function(a, b) {
            //to sort random
            return 0.5 - Math.random();
          });

          this.isLoaded.popular = true;
          this.popular = data;
          setTimeout(() => {
            this.$refs.popularComponent.triggerFn("popularSlider");
          }, 0);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getSubcategory(category, id) {
      let local = `http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=${category}&subcategory=${id}&limit=100&offset=0&domain=${this.host_Mix}`
      let live = `http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=${category}&subcategory=${id}&limit=100&offset=0&domain=${this.host_Mix}&lang=${this.lang_Mix}`;
      axios.get(live)
        .then(res => {
          let data = res.data.data;
          let temp_data = data.map(item => {
            let cat_trans = []
            let sub_trans = []
            if(item.category_translate != null){
              cat_trans = JSON.parse(item.category_translate);
            }
            if(item.subcategory_translate != null){
              sub_trans = JSON.parse(item.subcategory_translate);
            }

            item.titleSub_english = item.subcategory;
            item.route = item.subcategory;
            if (cat_trans != null && cat_trans != '') {
              if (this.lang_Mix != "english") {
                this.categoryTranslate = cat_trans[this.lang_Mix].title;

                if (sub_trans != null) {
                  item["titleSub_" + this.lang_Mix] = sub_trans[this.lang_Mix].title;
                }
              } else {
                for (let [key, value] of Object.entries(country_list)) {
                  if(this.country_Mix == key){
                    this.categoryTranslate = cat_trans[`${value.language}`].title;
                    if (sub_trans != null) {
                      item[`titleSub_${value.language}`] = sub_trans[`${value.language}`].title;
                    }
                  }else{
                    item.titleSub_english = item.subcategory;
                  }
                }
              }
            }

            if(item.subcategory_icon != null){
              let sub_icon = JSON.parse(item.subcategory_icon);
              if (sub_icon != null) {
                for (let [key, value] of Object.entries(sub_icon)) {
                  if (category == 'video') {
                    item.icon = sub_icon["mobiflix.vip"]["class"];
                  }else{
                    item.icon = sub_icon["mobizone.vip"]["class"];
                  }
                }
              }
            }
            
            return item;
          });

          this.isLoaded.subCategory = true;
          this.subcategory = temp_data;

          setTimeout(() => {
            this.$refs.childComponent.triggerFn("catSlider");
          }, 100);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCategoryTitle(lang) {
      if (lang == "english") {
        return this.category;
      }
      if (lang != "english") {
        return this.categoryTranslate;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main_title {
  color: black;
  text-transform: uppercase;
}

.subTitle {
  color: black;
  text-transform: capitalize;
}

.browse_link {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/miximo/browse/Category.vue